import { User } from '@auth0/auth0-react';
import { atom } from 'jotai';

import { getUserRoles } from '../Services/auth/utils.ts';

export const auth0UserAtom = atom<User | undefined>(undefined);

export const userIdSelector = atom((get) => get(auth0UserAtom)?.sub ?? '');

export const userRoleSelector = atom<'' | ApplicationUserRole>(
    (get) => getUserRoles(get(auth0UserAtom))[0] ?? ''
);
